module.exports = "### Toolbar Properties\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/Toolbars/Toolbar.md
 ** module id = 893
 ** module chunks = 0
 **/